﻿<template>
    <div class="slideout-content sl-content">

        <div id="tours" class="sl-wrap">
            <div class="sc-cal-head">
                <span class="sc-cal-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>
                </span>
                <div>
                    <h2 class="sc-cal-title">Select a tour</h2>
                    <p v-if="taglineCheck() == 'TOURSDATE'" class="sc-cal-intro">
                        <strong>{{FilteredProducts(tours_selected.products).length}} {{FilteredProducts(tours_selected.products).length == 1 ? 'tour' : 'tours'}}</strong> departing on <strong>{{search_date()}}</strong>
                    </p>
                    <p v-else-if="taglineCheck() == 'DATE'" class="sc-cal-intro">
                        Tours departing on <strong>{{search_date()}}</strong>
                    </p>
                    <p v-else-if="taglineCheck() == 'TOURS'" class="sc-cal-intro">
                        <strong>{{FilteredProducts(tours_selected.products).length}} {{FilteredProducts(tours_selected.products).length == 1 ? 'tour' : 'tours'}}</strong> departing on this day
                    </p>
                    <p v-else class="sc-cal-intro">Tours departing on this day</p>
                </div>
            </div>

            <div v-if="FilteredProducts(tours_selected.products).length == 0" class="ts-empty">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>
                <h2 class="ts-results-title">No tours depart on this day</h2>
                <p>Try another date in the calendar.</p>
            </div>

            <div v-else class="sl-list">
                <article class="tc-card sl-card" v-for="product in FilteredProducts(tours_selected.products)" :key="product.tour_id">
                    <button type="button" class="tc-media sl-media" :aria-label="'Dates & prices for ' + product.name" @click="product_selected(product)">
                        <img class="tc-image" :src="image(product)" :alt="imageAltText(product)" />
                        <span class="tc-badges">
                            <span class="tc-badge">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                                {{ isAAT() ? duration(product) : durationInDays(product) }}
                            </span>
                        </span>
                    </button>

                    <div class="sl-main">
                        <div class="tc-body">
                            <p v-if="isAgent_Login() && !isAAT() && getBrand(product.brand) != ''" class="sl-brand">{{ getBrand(product.brand) }}</p>
                            <p v-if="product.start_location?.city" class="tc-location">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" /><circle cx="12" cy="10" r="2.5" /></svg>
                                Departs {{ product.start_location.city }}
                            </p>
                            <h3 class="tc-title">
                                <a @click="product_selected(product)">{{ product.name }}</a>
                            </h3>
                            <p class="tc-desc">{{ removeHtmlTags(getDescription(product)) }}</p>
                        </div>

                        <footer class="tc-foot">
                            <div class="tc-price">
                                <span class="tc-price-label">From</span>
                                <strong>{{ price(product) }}</strong>
                                <small>{{ currency() }} per person</small>
                            </div>

                            <div class="tc-actions">
                                <a v-if="product.web_url" :href="product.web_url" target="_blank" rel="noopener" class="tc-link">Tour details</a>
                                <button type="button" class="button button-standard xsmall tc-book" @click="product_selected(product)">Dates &amp; prices</button>
                            </div>
                        </footer>
                    </div>
                </article>
            </div>
        </div>

        <div class="slideout" :hidden="isHidden"
            x-transition:enter="transition ease-out duration-500 -mr-64"
            x-transition:enter-start=""
            x-transition:enter-end="transform -translate-x-64"
            x-transition:leave="transform ease-out duration-75"
            x-transition:leave-start=""
            x-transition:leave-end="transform translate-x-64"
            style="z-index: 201 !important;">
            <div class="slideout-inner">
                <button class="close no-bg" aria-label="Close" @click="isHidden = true"></button>

                <div class="slideout-content">
                    <itinerary :tour_id="tour_id" :banner="true" ref="itinerary" v-if="!isHidden"></itinerary>
                </div>
            </div>

        </div>
    </div>
</template>

<script lang="ts" src="./tour_list.ts"></script>